import { all, takeLatest } from "redux-saga/effects";
import httpClient from "../services/http.client";
import * as Effects from "redux-saga/effects";
import { successMessage } from "../../utilities/notification";
import {
  SETTING_DETAIL,
  UPDATE_SETTING,
} from "../actions/settings.actions.types";

const call = Effects.call;

function* getSettingDetails({ payload: { page, callback } }) {
  const payload = {
    method: "get",
    url: "settings",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: page == "products" ? false : true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* updateSetting({ payload: { data, callback } }) {
  const payload = {
    method: "post",
    url: "settings",
    data,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* Setting() {
  yield all([
    takeLatest(SETTING_DETAIL, getSettingDetails),
    takeLatest(UPDATE_SETTING, updateSetting),
  ]);
}

export default Setting;
